import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ISkillBlockResource } from "../types";

export type ISkillBlockDeleteMutationParameters = {
    skillBlock: RelationalValue<ISkillBlockResource>;
};

export type ISkillBlockDeleteMutationResult = void;

export const skillBlockDeleteMutation: IApiMutationFunction<ISkillBlockDeleteMutationParameters> = ({ skillBlock }) => {
    return {
        method: "DELETE",
        url: `/skill_blocks/${mapRelationalValue(skillBlock)}`,
    };
};

export const useSkillBlockDeleteMutation = createApiMutationHook<
    ISkillBlockDeleteMutationParameters,
    ISkillBlockDeleteMutationResult
>(skillBlockDeleteMutation);
